/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ButtonIconSquare/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Children from 'Simple/Children'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function ButtonIconSquare({
  children,
  viewPath = "/DesignSystem/ButtonIconSquare",
  height = 280,
  marginLeft = 0,
  onClick,
  width = 250,
  marginTopText = 10,
  text,
  isSelected
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtTypographyFontsizeM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.fontSize.m'
        })
  return (<React.Fragment
>
<button
  data-testid="ButtonIconSquare.ButtonIconSquare"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 style={{'--bc-1-1xBFqK': dtColorsWhite,'--bblr-2-1xBFqK': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--bbrr-3-1xBFqK': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--btlr-4-1xBFqK': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--btrr-5-1xBFqK': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--h-6-1xBFqK': typeof height === 'number' ? `${height}px` : height,'--ml-7-1xBFqK': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--pl-8-1xBFqK': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pr-9-1xBFqK': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--w-11-1xBFqK': typeof width === 'number' ? `${width}px` : width,'--s-10-1xBFqK': isHovered ? 1.05 : 1}}
 className={`views-block ${styles.ButtonIconSquare1}`}
>
<Children
  viewPath={`${viewPath}/Children`}
 isSelected={isSelected} isHovered={isHovered} isSelectedHovered={isSelectedHovered}
>
{children}
</Children>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color="#323232"
 fontSize={dtTypographyFontsizeM}
 fontWeight={300}
 marginTop={marginTopText}
 text={text}
/>
</button>
</React.Fragment>)
}